var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 21.5,
    viewBox: "0 0 25.6 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.079,14.744a1.025,1.025,0,0,0-.064-.2L26.6,8.9a3.7,3.7,0,0,0-3.46-2.148H10.465A3.7,3.7,0,0,0,7.006,8.9L4.583,14.546a1.007,1.007,0,0,0-.083.4V26.225A1.025,1.025,0,0,0,5.525,27.25h2.05A1.025,1.025,0,0,0,8.6,26.225V25.2H25v1.025a1.025,1.025,0,0,0,1.025,1.025h2.05A1.025,1.025,0,0,0,29.1,26.225V14.95a1.035,1.035,0,0,0-.02-.206ZM9.625,21.1a2.05,2.05,0,1,1,2.05-2.05A2.05,2.05,0,0,1,9.625,21.1Zm14.35,0a2.05,2.05,0,1,1,2.05-2.05A2.05,2.05,0,0,1,23.975,21.1Zm-16.9-7.175L8.888,9.707A1.683,1.683,0,0,1,10.465,8.8h12.67a1.684,1.684,0,0,1,1.577.907l1.809,4.218Z",
    transform: "translate(-4 -6.25)",
    fill: "none",
    stroke: "#6d6e79",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.dfb95c36ef3dc9f48db2f1aac968a4be.svg";
export { ForwardRef as ReactComponent };